import React, {Component} from "react"
import CogolandActivityLineChart from "./CogolandActivityLineChart"
import IBox from "../../../../components/IBox"
import CogoLandSessionStatusLabel from "../../../cogoland/component/CogoLandSessionStatusLabel"
import CogoLandActivityStatusLabel, {statusTextMap} from "../../../cogoland/component/CogoLandActivityStatusLabel"
import {convertToDisplayFormat} from "../../../../util/DateUtil"
import {
  COGOLAND_ACTIVITY_TYPE_DESC,
  COGOLAND_SESSION_DATE_FORMAT,
  COGOLAND_SESSION_DATE_TIME_FORMAT
} from "../../../../constants"
import {injectIntl} from "react-intl"
import InfoPopover from "../../../../components/InfoPopover"

class CogolandSessionDetails extends Component {

  render() {

    const format = this.props.intl.formatMessage

    const buildInfoTable = (data) => {
      return (
        <div className="row">
          {data.map(it => (
            <div className="col-xs-4">
              <small>{it.label}</small>
              {_.isString(it.value) || typeof it.value === 'number' ? <h4>{it.value}</h4> : it.value}
            </div>
          ))}
        </div>
      )
    }

    const session = this.props.session

    const activityTemplate = (a) => {
      const status = a.status.name

      const maskValue = v => (v ? `${v}` : '-')

      const type = a.type.name
      const isMCQ = _.startsWith(type, 'MCQ')
      const isGame = _.startsWith(type, 'GAME')
      const isPreparation = _.startsWith(type, 'PREPARATION')
      const isPVT = _.startsWith(type, 'PVT')

      const renderType = type => (
        COGOLAND_ACTIVITY_TYPE_DESC[type]
      )

      const activityInfoData = [
        {
          label: format({id: 'cogoland.activity.type'}),
          value: format({id: `cogoland.activity.type.${type}`}),
        },
        {
          label: format({id: 'cogoland.activity.status'}),
          value: format({id: `cogoland.activity.status.${status}`})
        },
        {
          label: format({id: 'cogoland.activity.date.completed'}),
          value: maskValue(convertToDisplayFormat(a.dateTimeCompleted, COGOLAND_SESSION_DATE_TIME_FORMAT)),
        },

      ]

      if (isPVT) {
        activityInfoData.push({
          label: format({id: 'cogoland.activity.average.reaction.time'}),
          value: maskValue(Math.round(a.overallAverageReactionTime)),
        },)
        activityInfoData.push({
          label: format({id: 'cogoland.activity.average.accuracy'}),
          value: maskValue(Math.round(a.overallAverageAccuracy)),
        },)
      }

      if (isMCQ) {
        activityInfoData.push({
          label: format({id: 'cogoland.activity.average.attention'}),
          value: maskValue(Math.round(a.averageAttention)),
        },)
        activityInfoData.push({
          label: format({id: 'cogoland.activity.mcq.score'}),
          value: maskValue(a.mcqScore ? `${Math.round(a.mcqScore)}/20` : '-'),
        },)
      }
      if (isGame) {
        activityInfoData.push({
          label: format({id: 'cogoland.activity.average.attention'}),
          value: maskValue(Math.round(a.averageAttention)),
        },)
        activityInfoData.push({
          label: format({id: 'cogoland.activity.game.score'}),
          value: maskValue(Math.round(a.gameScore)),
        },)
      }
      if (isPreparation) {
        activityInfoData.push({
          label: format({id: 'cogoland.activity.average.relaxation'}),
          value: maskValue(Math.round(a.averageRelaxation)),
        },)
      }

      let isAdvancedGame = type === 'GAME_LEVEL_2' || type === 'GAME_LEVEL_3'
      if (isAdvancedGame) {
        activityInfoData.push({
          label: format({id: 'cogoland.activity.correct.jumps'}),
          value: a.numberOfFruitsCollectedCorrectly,
        })
        activityInfoData.push({
          label: format({id: 'cogoland.activity.wrong.moves'}),
          value: a.numberOfMissesOfNeededFruit + a.numberOfWrongFruitsCollected + a.numberOfWrongJumps
        })
      }

      return (<IBox title={`${format({id: 'cogoland.activity'})} ${a.index}`}>
        {buildInfoTable(activityInfoData)}

        {status === 'UPLOADED' ?
          <div>
            {isPreparation?<IBox title={format({id: 'relaxation.chart'})}>
              <CogolandActivityLineChart
                label={format({id: 'relaxation'})}
                movingAvgSize={15}
                suggestedMax={100}
                dataStr={a.relaxationOverTime}/>
            </IBox>:""}
            {isGame ?
              [<IBox title={format({id: 'attention.chart'})}>
                <CogolandActivityLineChart
                  label={format({id: 'attention'})}
                  movingAvgSize={15}
                  suggestedMax={100}
                  dataStr={a.attentionOverTime}/>
              </IBox>,
              <IBox title={format({id: 'game.score.chart'})}>
                <div className="text-right">
                  <InfoPopover desc={
                    isAdvancedGame ?
                      format({id: 'cogoland.activity.advanced.game.score.chart.info'})
                      :
                      format({id: 'cogoland.activity.basic.game.score.chart.info'})
                  }/>
                </div>
                <CogolandActivityLineChart
                  label={format({id: 'cogoland.activity.game.score'})}
                  step={100}
                  dataStr={a.gameScoreOverTime}/>
              </IBox>] : ""}
            {/*{isMCQ?
              <IBox title={format({id:'mcq.score.chart'})}>
                <CogolandActivityLineChart
                  label={format({id:'cogoland.activity.mcq.score'})}
                  step={5}
                  suggestedMax={20}
                  dataStr={a.mcqScoreOverTime}/>
              </IBox>:""}*/}

          </div>
          : ''}
      </IBox>)
    }

    return (
      <div>
        <IBox title={`${format({id: 'cogoland.session'})} ${session.index}`}>
          {buildInfoTable([
            {
              label: format({id: 'status'}),
              value: <div style={{paddingTop: 3}}>
                <CogoLandSessionStatusLabel status={session.status}
                                            text={format({id: `cogoland.session.status.${session.status}`})}/>
              </div>
            },
            {
              label: format({id: 'date.unlocked'}),
              value: convertToDisplayFormat(session.dateTimeUnlock, COGOLAND_SESSION_DATE_FORMAT),
            },
            {
              label: format({id: 'date.completed'}),
              value: convertToDisplayFormat(session.dateTimeCompleted, COGOLAND_SESSION_DATE_FORMAT),
            }
          ])}
        </IBox>

        {_.sortBy(session.activities, 'index').map(a => activityTemplate(a))}
      </div>
    )
  }
}

export default injectIntl(CogolandSessionDetails)



// WEBPACK FOOTER //
// ./src/routes/enterprise/dashboard/components/CogolandSessionDetails.js